import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

export interface UseScheduleListSearchOptions {
  debounceMs?: number
  initialSearch?: string
  setCurrentPage?: Dispatch<SetStateAction<number>>
}

export interface UseScheduleListSearchResult {
  searchInput: string
  setSearchInput: Dispatch<SetStateAction<string>>
  debouncedSearch: string
}

export const useScheduleListSearch = ({
  debounceMs = 300,
  initialSearch = '',
  setCurrentPage,
}: UseScheduleListSearchOptions = {}): UseScheduleListSearchResult => {
  const [searchInput, setSearchInput] = useState(initialSearch)
  const [debouncedSearch, setDebouncedSearch] = useState(initialSearch)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput)
    }, debounceMs)

    return () => clearTimeout(timer)
  }, [debounceMs, searchInput])

  useEffect(() => {
    if (!setCurrentPage) return

    setCurrentPage((previousPage) => (previousPage === 1 ? previousPage : 1))
  }, [debouncedSearch, setCurrentPage])

  return {
    searchInput,
    setSearchInput,
    debouncedSearch,
  }
}
